/**
 * Launch setting for updated NAM commission model announcement phase
 * This setting also serves country audience control, thus it could be reused for non-NAM pricing update.
 * If we need to clean up, every usage needs to change to look up brand's based_in or ip address country
 * to decide the logic.
 */ export var UPDATED_NAM_COMMISSION_ANNOUNCEMENT_230414 = 'UPDATED_NAM_COMMISSION_ANNOUNCEMENT_230414';
